import React, { ReactElement, useState, ChangeEvent } from 'react'
import { Navigate } from 'react-router-dom'
import { loginUser } from '../../api/user'
import Button from '../../components/button'
import Inputfield from '../../components/input/input-field'
import Text from '../../components/text'
import { Alert } from '../../constants/sweet-alert'
import { useConnectedUserContext } from '../../contexts/connected-user'
import {
  ConnexionScreen,
  ConnexionStyled,
  StyledImg,
} from './styled-components'
import logo from './logo.png'

function Connexion(): ReactElement {
  const { connectedUser } = useConnectedUserContext()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)

  const onLoginClick = () => {
    setLoading(true)
    const payload = { email, password }
    loginUser(payload).then((data) => {
      if (typeof data !== 'number' && data.isAdmin) {
        localStorage.setItem('token', data.user.token)
        window.location.replace('/dashboard')
      } else {
        setLoading(false)
        Alert.fire({ icon: 'warning', title: 'الرجاء التثبت من المعطيات' })
      }
    })
  }

  if (connectedUser) {
    return <Navigate to="/dashboard" />
  }

  return (
    <ConnexionScreen>
      <ConnexionStyled>
        <StyledImg src={logo} />
        <Inputfield
          value={email}
          labelName="البريد اللإلكتروني أو المعرف الكشفي"
          onValueChange={(event: ChangeEvent<HTMLInputElement>) =>
            setEmail(event.target.value)
          }
          type="email"
          onKeyPress={onLoginClick}
        />
        <Inputfield
          value={password}
          labelName="كلمة السر"
          onValueChange={(event: ChangeEvent<HTMLInputElement>) =>
            setPassword(event.target.value)
          }
          type="password"
          onKeyPress={onLoginClick}
        />

        <Button
          loading={loading}
          size="100%"
          onClick={onLoginClick}
          color="darkRed"
        >
          <Text weight="bold">تسجيل الدخول</Text>
        </Button>
      </ConnexionStyled>
    </ConnexionScreen>
  )
}
export default Connexion
